export const needsEmployer = (category?: string) => category === 'PERMANENT' || category === 'CONTRACT';

export function incomeProfileRequest(profile: any) {
  return {
    ...(typeof profile.isPreviouslyDisadvantaged === 'boolean' && {isPreviouslyDisadvantaged: profile.isPreviouslyDisadvantaged}),
    dateOfBirth: profile.dateOfBirth,
    employmentType: profile.employmentType,
    employer: needsEmployer(profile.employmentType) ? profile.employer : '',
    incomeSource: needsEmployer(profile.employmentType) ? profile.employer : profile.incomeSource,
    monthlyNetIncome: profile.monthlyNetIncome,
    monthlyLivingExpenses: profile.monthlyLivingExpenses
  };
}

/** Deliberately never infer net income from legacy salary/monthlyIncome. */
export function capturedIncomeProfile(profile: any = {}) {
  return {
    ...(typeof profile.isPreviouslyDisadvantaged === 'boolean' && {isPreviouslyDisadvantaged: profile.isPreviouslyDisadvantaged}),
    dateOfBirth: profile.dateOfBirth?.split('T')[0] || '',
    employmentType: profile.employmentType || '',
    employer: profile.employerName ?? profile.employer ?? '',
    incomeSource: profile.incomeSource || '',
    monthlyNetIncome: profile.monthlyNetIncome ?? undefined,
    monthlyLivingExpenses: profile.monthlyLivingExpenses ?? undefined
  };
}

export function individualIncomeErrors(profile: any = {}) {
  const errors: {field: string; message: string}[] = [];
  const add = (field: string, message: string) => errors.push({field, message});
  const birth = new Date(`${profile.dateOfBirth}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(profile.dateOfBirth || '') || !Number.isFinite(birth.getTime())
      || birth.toISOString().slice(0, 10) !== profile.dateOfBirth || birth > new Date())
    add('dateOfBirth', 'Enter a valid date of birth, not in the future.');
  return [...errors, ...individualEmploymentErrors(profile), ...individualFinancialErrors(profile)];
}

/** Required on the later Employment Details page and before Review/submission. */
export function individualEmploymentErrors(profile: any = {}) {
  const errors: {field: string; message: string}[] = [];
  const add = (field: string, message: string) => errors.push({field, message});
  if (!['PERMANENT', 'CONTRACT', 'SELF_EMPLOYED', 'UNEMPLOYED'].includes(profile.employmentType))
    add('employmentType', 'Select an employment category.');
  const sourceField = needsEmployer(profile.employmentType) ? 'employer' : 'incomeSource';
  if (!profile[sourceField]?.trim() || profile[sourceField].length > 255)
    add(sourceField, 'Enter an employer or income source (maximum 255 characters).');
  return errors;
}

/** Early affordability needs financial amounts, independently of later employment capture. */
export function individualFinancialErrors(profile: any = {}) {
  const errors: {field: string; message: string}[] = [];
  const add = (field: string, message: string) => errors.push({field, message});
  for (const field of ['monthlyNetIncome', 'monthlyLivingExpenses']) {
    const value = profile[field];
    if (!Number.isFinite(value) || value < 0 || value > Number.MAX_SAFE_INTEGER / 100
        || Math.abs(value * 100 - Math.round(value * 100)) > 0.000001)
      add(field, field === 'monthlyLivingExpenses' ? 'Complete each monthly expense item with a non-negative amount and at most two decimal places.'
        : 'Enter a non-negative monthly amount with at most two decimal places.');
  }
  return errors;
}
